/* readmore.js — robust toggle fix */
(function () {
  function processWrapper(wrapper) {
    var containers = wrapper.querySelectorAll('.tabbed-content--content.rte, .tabbed-content--content');
    var marker = '{read more}';

    for (var i = 0; i < containers.length; i++) {
      var el = containers[i];
      if (el.getAttribute('data-readmore-initialized') === '1') continue;

      var html = el.innerHTML || '';
      var idx = html.indexOf(marker);

      if (idx !== -1) {
        var beforeHTML = html.slice(0, idx);
        var afterHTML  = html.slice(idx + marker.length);

        var wrap = document.createElement('div');
        wrap.className = 'readmore-wrapper';

        var initial = document.createElement('div');
        initial.className = 'readmore-initial';
        initial.innerHTML = beforeHTML;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'readmore-toggle';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-controls', 'readmore-extra-' + i);
        btn.innerHTML = 'Read More';

        var extra = document.createElement('div');
        extra.className = 'readmore-extra';
        extra.id = 'readmore-extra-' + i;
        extra.setAttribute('hidden', 'hidden');
        extra.style.maxHeight = '0px';
        extra.style.overflow = 'hidden';
        extra.innerHTML = afterHTML;

        wrap.appendChild(initial);
        wrap.appendChild(btn);
        wrap.appendChild(extra);

        el.innerHTML = '';
        el.appendChild(wrap);
        el.setAttribute('data-readmore-initialized', '1');

        // Reveal this content block (it was pre-hidden by CSS)
        el.style.opacity = '1';

        (function (button, panel) {
          var animating = false;
          var TRANSITION_MS = 320; // keep in sync with CSS (300ms + small buffer)
          var endTimer = null;

          function clearEndTimer() {
            if (endTimer) { clearTimeout(endTimer); endTimer = null; }
          }

          function onEndOnce(handler) {
            var called = false;
            function wrapped(e) {
              if (e && e.propertyName && e.propertyName !== 'max-height') return;
              if (called) return;
              called = true;
              panel.removeEventListener('transitionend', wrapped);
              clearEndTimer();
              handler();
            }
            panel.addEventListener('transitionend', wrapped);
            // Fallback in case transitionend doesn't fire
            endTimer = setTimeout(wrapped, TRANSITION_MS + 50);
          }

          function openPanel() {
            if (animating) return;
            animating = true;

            // Ensure it's renderable but collapsed
            panel.removeAttribute('hidden');
            panel.style.overflow = 'hidden';

            // Turn off transition while we set the starting state
            var prevTransition = panel.style.transition;
            panel.style.transition = 'none';
            panel.style.maxHeight = '0px';
            panel.offsetHeight; // reflow so 0px is committed

            // Measure target height AFTER it’s in the flow
            var target = panel.scrollHeight + 'px';

            // Re-enable transition and animate to target
            panel.style.transition = 'max-height 300ms ease';
            // Use a frame so the browser treats the change as a transition, not a jump
            requestAnimationFrame(function () {
                panel.style.maxHeight = target;
            });

            onEndOnce(function () {
                // Allow natural growth after opening
                panel.style.transition = prevTransition || '';
                panel.style.maxHeight = 'none';
                animating = false;
            });

            button.setAttribute('aria-expanded', 'true');
            button.innerHTML = 'Read Less';
            }

            function closePanel() {
            if (animating) return;
            animating = true;

            panel.style.overflow = 'hidden';

            // If currently 'none', lock to the pixel height first
            if (panel.style.maxHeight === '' || panel.style.maxHeight === 'none') {
                panel.style.transition = 'none';
                panel.style.maxHeight = panel.scrollHeight + 'px';
                panel.offsetHeight; // reflow
            }

            // Now animate to 0
            panel.style.transition = 'max-height 300ms ease';
            panel.style.maxHeight = '0px';

            onEndOnce(function () {
                panel.setAttribute('hidden', 'hidden');
                panel.style.transition = '';
                animating = false;
            });

            button.setAttribute('aria-expanded', 'false');
            button.innerHTML = 'Read More';
            }


          button.addEventListener('click', function () {
            var expanded = button.getAttribute('aria-expanded') === 'true';
            if (expanded) closePanel(); else openPanel();
          });

          // Keep height correct if images load inside the hidden content
          var imgs = panel.querySelectorAll('img');
          for (var k = 0; k < imgs.length; k++) {
            imgs[k].addEventListener('load', function () {
              if (btn.getAttribute('aria-expanded') === 'true' && panel.style.maxHeight !== 'none') {
                panel.style.maxHeight = panel.scrollHeight + 'px';
              }
            });
          }
        })(btn, extra);
      } else {
        // No marker — still reveal the block
        el.style.opacity = '1';
      }
    }

    // If the wrapper itself had a prehide, clear it
    wrapper.className = (wrapper.className || '').replace(/\brm-prehide-block\b/, '').trim();
    wrapper.style.opacity = '';
  }

  function init() {
    var wrappers = document.querySelectorAll('.tabbed-content-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      processWrapper(wrappers[i]);
    }
  }

  try { init(); } catch (e) {}
  setTimeout(function () { try { init(); } catch (e) {} }, 200);
})();
